var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 8l18 17L38 8v7L20 32 2 15z","fill":"#434c56"}));
}

Arrow.defaultProps = {"viewBox":"0 0 40 40","className":"icon color--grey-500"};

module.exports = Arrow;

Arrow.default = Arrow;
